/* eslint-disable */

import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'

import { configure, index } from 'instantsearch.js/es/widgets'

import {
  connectInfiniteHits,
  connectStats,
  connectSearchBox,
} from 'instantsearch.js/es/connectors'

import translate from '../translations'

/* global config */

// import Masonry from 'masonry-layout'

// import onResize from '../utils/onResize'

import getQueryVariable from '../utils/getQueryVariable'
import moment from 'moment'
import slugify from '../utils/slugify'
import stringToHTML from '../utils/stringToHTML'
import truncate from '../utils/truncate'

import downloadTpl from './cards-templates/download'
import eventTpl from './cards-templates/event'
import jobTpl from './cards-templates/job'
import memberTpl from './cards-templates/member'
import newsTpl from './cards-templates/news'
import pageTpl from './cards-templates/page'
import pressReleaseTpl from './cards-templates/press-release'
import pressSummaryTpl from './cards-templates/press-summary'
import reportTpl from './cards-templates/report'
import socialNetworkTpl from './cards-templates/social-network'

export default {
  name: 'search',

  isMobile: false,

  forcedType: '',

  hitsPerPage: 99999,
  hitsDisplayed: 0,
  firstLoading: true,
  renderTimer: 0,

  ui: {
    'buttonsLoadMore[]': '[js-load-more]',
  },

  events: [
    {
      target: 'buttonsLoadMore',
      on: 'click',
      handle(e) {
        e.preventDefault()
        // this.hitsDisplayed = 0
        this.search.helper.state.query = this.input.value
        this.forcedType = e.target.parentNode.getAttribute('data-type')
        this.search.helper.search()
      },
    },
  ],

  componentDidMount() {
    this.input = document.querySelector('[js-search-common-form-input]')
    this.keywords = document.querySelector('.keywords span')
    this.input.value = getQueryVariable('query')
      ? this.strip(decodeURI(getQueryVariable('query')))
      : ''
    this.blockNews = this.el.querySelector('.results[data-type="news"]')
    this.blockMembers = this.el.querySelector('.results[data-type="members"]')
    this.blockPages = this.el.querySelector('.results[data-type="page"]')
    this.blockDocument = this.el.querySelector('.results[data-type="document"]')
    this.blockReport = this.el.querySelector('.results[data-type="report"]')
    this.blockPressSummary = this.el.querySelector(
      '.results[data-type="press-summary"]'
    )
    this.blockPressRelease = this.el.querySelector(
      '.results[data-type="press-release"]'
    )
    this.blockJobs = this.el.querySelector('.results[data-type="job-card"]')
    this.blockEvents = this.el.querySelector('.results[data-type="event"]')
    this.blockSocialNetworks = this.el.querySelector(
      '.results[data-type="social-network"]'
    )

    this.locale = document.querySelector('html').getAttribute('lang')

    const searchIndex = `${config.algolia.env}_pages`
    // const searchIndex = `local_frontUsers`
    let searchFilter = 'visible:true'
    // commenté car membres n'ont pas d'attributs locale
    // searchFilter += ` AND locale:${this.locale}`
    this.widgets = []
    console.log('config', config)
    // console.log(config.algolia)

    this.search = instantsearch({
      indexName: searchIndex,
      searchClient: algoliasearch(
        config.algolia.applicationID,
        config.algolia.apiKeyMultiIndexes
      ),
      numberLocale: this.locale,
      // comment car bug IE11..
      // routing: true,
    })

    this.manageSearchBox()
    this.manageResults()
    this.manageStats()

    const indexWidget = index({
      indexName: `${config.algolia.env}_frontUsers`,
      // indexId: 'instant_search_members',
    }).addWidgets(this.widgets)

    this.search.addWidget(indexWidget)

    this.search.addWidgets([
      configure({
        hitsPerPage: this.hitsPerPage,
        distinct: false,
        filters: searchFilter,
      }),
      this.customSearchBoxWidget,
      this.customInfiniteHitsWidget,
      this.customStatsWidget,
      /*index({
        indexName: `${config.algolia.env}_frontUsers`,
      }).addWidgets(this.widgets),*/
    ])

    this.search.on('render', e => {
      // Do something on render
      // hide / display bt reset if a filter is selected or not
      // document.querySelector('.filtered-grid__filters__list__item--selected') ? this.btResetFilters.classList.remove('invisible') : this.btResetFilters.classList.add('invisible')
    })

    this.search.start()
  },

  strip(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  },

  manageSearchBox() {
    // Create a render function
    const renderSearchBox = (renderOptions, isFirstRender) => {
      const {
        query,
        refine,
        clear,
        isSearchStalled,
        widgetParams,
      } = renderOptions

      if (isFirstRender) {
        refine(this.input.value)
      }

      // this.queryString = query
      // widgetParams.container.querySelector('span').hidden = !isSearchStalled;
    }

    // create custom widget
    const customSearchBox = connectSearchBox(renderSearchBox)
    this.customSearchBoxWidget = customSearchBox({
      container: document.querySelector('.searchform__border'),
      // placeholder: 'Votre recherche',
      autofocus: false,
      // searchAsYouType: true,
      showReset: false,
      showSubmit: false,
      showLoadingIndicator: false,
    })

    // instantiate custom widget
    /* this.search.addWidget(
      this.customSearchBoxWidget
    )*/

    // this.widgets.push(this.customSearchBoxWidget)
  },

  manageResults() {
    // Create the render function
    const renderInfiniteHits = (renderOptions, isFirstRender) => {
      const { hits, showMore, isLastPage, widgetParams } = renderOptions

      const parentContainer = widgetParams.container // .parentNode

      // first render, construct empty ul && button more
      if (isFirstRender) {
        // const button = document.createElement('button')
        // button.classList.add('button')
        // button.classList.add('button--black', 'my-5')
        // button.textContent = 'Afficher plus'
        // button.addEventListener('click', () => {
        //   showMore()
        // })
        // const wrapper = document.createElement('div')
        // wrapper.classList.add('wrapper', 'w-full', 'text-left')
        // widgetParams.container.appendChild(wrapper)
        // parentContainer.appendChild(button)
        // return
      }
      const arrayNews = []
      this.arrayMembers = []
      const arrayPages = []
      const arrayReports = []
      const arrayDocument = []
      const arrayPressRelease = []
      const arrayPressSummary = []
      const arrayJobs = []
      const arrayEvents = []
      const arraySocialNetwork = []

      const mediaPath = `//${config.cloudinary.host}/${
        config.cloudinary.options.cloud_name
      }/`

      let imgW = 650
      let imgH = 400
      if (this.type === 'document') {
        imgW = 280
        imgH = 363
      }

      // for (let hit of hits) {
      hits.forEach(hit => {
        let cardType = hit._highlightResult.type
          ? hit._highlightResult.type.value
          : ''
        if (hit.initial) {
          cardType = 'member'
        }

        if (cardType) {
          switch (cardType) {
            case 'news':
              if (hit.locale === this.locale) arrayNews.push(hit)
              break
            case 'member':
              this.arrayMembers.push(hit)
              break
            case 'document':
              if (hit.locale === this.locale) arrayDocument.push(hit)
              break
            case 'press-release':
              if (hit.locale === this.locale) arrayPressRelease.push(hit)
              break
            case 'press-summary':
              if (hit.locale === this.locale) arrayPressSummary.push(hit)
              break
            case 'social-network':
              if (hit.locale === this.locale) arraySocialNetwork.push(hit)
              break
            default:
            case 'list':
            case 'page':
              if (hit.locale === this.locale) arrayPages.push(hit)
              break
          }
        }
      })

      if (arrayNews.length > 0) {
        for (let i = 0; i < arrayNews.length; i++) {
          const hit = arrayNews[i]
          if (hit._highlightResult.contentProperties.event) {
            arrayEvents.push(hit)
            arrayNews.splice(i, 1)
          }
        }
      }

      if (arrayDocument.length > 0) {
        for (let i = 0; i < arrayDocument.length; i++) {
          const hit = arrayDocument[i]
          if (!hit.type) {
            arrayReports.push(hit)
            arrayDocument.splice(i, 1)
          }
        }
      }

      /*console.log(hits)
      console.log('news', arrayNews.length)
      console.log('members', this.arrayMembers.length)
      console.log('page', arrayPages.length)
      console.log('report', arrayReports.length)
      console.log('dov', arrayDocument.length)
      console.log('press Release', arrayPressRelease.length)
      console.log('press SUM', arrayPressSummary.length)
      console.log('jobs', arrayJobs.length)
      console.log('events', arrayEvents.length)
      console.log('SN', arraySocialNetwork.length)*/
      if (this.forcedType !== '') {
        let block
        let array = []
        switch (this.forcedType) {
          case 'news':
            block = this.blockNews
            array = arrayNews
            break
          case 'members':
            block = this.blockMembers
            array = this.arrayMembers
            break
          case 'page':
            block = this.blockPages
            array = arrayPages
            break
          case 'document':
            block = this.blockDocument
            array = arrayDocument
            break
          case 'report':
            block = this.blockReport
            array = arrayReports
            break
          case 'press-release':
            block = this.blockPressRelease
            array = arrayPressRelease
            break
          case 'press-summary':
            block = this.blockPressSummary
            array = arrayPressSummary
            break
          case 'job-card':
            block = this.blockJobs
            array = arrayJobs
            break
          case 'event':
            block = this.blockEvents
            array = arrayEvents
            break
          case 'social-network':
            block = this.blockSocialNetworks
            array = arraySocialNetwork
            break
        }

        const total = parseInt(
          block.querySelector('.count').innerText.replace(/[\$\(\),]/g, '')
        ) //array.length
        const hitsDisplayed = block.querySelectorAll('.results__wrapper li')
          .length
        const limit = parseInt(block.getAttribute('data-limit'))
        const deletedArray = array.splice(hitsDisplayed, limit)

        this.setUpBlock(block, deletedArray, this.forcedType)
        setTimeout(() => {
          if (block.querySelectorAll('li').length >= total) {
            block.querySelector('[js-load-more]').classList.add('hidden')
          }
        }, 300)
      } else {
        if (arrayNews.length > 0) {
          this.setUpBlock(this.blockNews, arrayNews, 'news')
        }

        if (this.arrayMembers.length > 0) {
          this.setUpBlock(this.blockMembers, this.arrayMembers, 'members')
        }

        if (arrayPages.length > 0) {
          this.setUpBlock(this.blockPages, arrayPages, 'page')
        }

        if (arrayDocument.length > 0) {
          this.setUpBlock(this.blockDocument, arrayDocument, 'document')
        }

        if (arrayReports.length > 0) {
          this.setUpBlock(this.blockReport, arrayReports, 'report')
        }

        if (arrayPressRelease.length > 0) {
          this.setUpBlock(
            this.blockPressRelease,
            arrayPressRelease,
            'press-release'
          )
        }

        if (arrayPressSummary.length > 0) {
          this.setUpBlock(
            this.blockPressSummary,
            arrayPressSummary,
            'press-summary'
          )
        }

        if (arrayJobs.length > 0) {
          this.setUpBlock(this.blockJobs, arrayJobs, 'job-card')
        }

        if (arrayEvents.length > 0) {
          this.setUpBlock(this.blockEvents, arrayEvents, 'event')
        }

        if (arraySocialNetwork.length > 0) {
          this.setUpBlock(
            this.blockSocialNetworks,
            arraySocialNetwork,
            'social-network'
          )
        }
      }

      this.triggerResizeForHeaderCalculation()
    }

    // Create the custom widget
    const customInfiniteHits = connectInfiniteHits(renderInfiniteHits)
    this.customInfiniteHitsWidget = customInfiniteHits({
      container: this.el,
    })
    // Instantiate the custom widget
    /*this.search.addWidget(
      this.customInfiniteHitsWidget
    )*/

    this.widgets.push(this.customInfiniteHitsWidget)
  },

  manageStats() {
    // Create the render function
    const renderStats = (renderOptions, isFirstRender) => {
      const { nbHits, processingTimeMS, query, widgetParams } = renderOptions

      if (isFirstRender || this.forcedType !== '') {
        return
      }

      let totalHits = nbHits + this.blockMembers.childElementCount
      // console.log('stats', query, nbHits)

      if (this.input.value.length > 0) {
        let wording =
          totalHits > 1
            ? ` ${translate('RESULTS_FOR')}`
            : totalHits <= 1
            ? ` ${translate('RESULT_FOR')}`
            : ''

        if (totalHits > 1) {
          widgetParams.container.innerHTML = `<span class="stats__label">${wording}</span>`
        } else {
          widgetParams.container.innerHTML = `<span class="stats__number mr-2">${totalHits}</span><span class="stats__label">${wording}</span>`
        }
        // widgetParams.container.innerHTML = `<span class="stats__number mr-2">${nbHits}</span><span class="stats__label">${wording}</span>`
        // widgetParams.container.innerHTML = `<span class="stats__label">${wording}</span>`
        this.keywords.innerHTML = this.input.value
      } else {
        widgetParams.container.innerHTML = ''
        this.keywords.innerHTML = ''
      }
    }

    // Create the custom widget
    const customStats = connectStats(renderStats)
    this.customStatsWidget = customStats({
      container: this.el.querySelector('.stats'),
    })

    // Instantiate the custom widget
    /*this.search.addWidget(
      this.customStatsWidget
    )*/

    this.widgets.push(this.customStatsWidget)
  },

  setUpBlock(block, cardsArray, type) {
    let cards = cardsArray

    if (this.forcedType === '')
      block.querySelector('.count').innerText = `(${cards.length})`

    const limit = parseInt(block.getAttribute('data-limit'))
    const btMore = block.querySelector('.bt.tag--more')

    if (cards.length > limit) {
      cards = cardsArray.slice(0, limit)
      btMore.classList.remove('hidden')
    } else if (this.forcedType === '') {
      btMore.classList.add('hidden')
    }

    const wrapper = block.querySelector('.results__wrapper')
    // for (let hit of cards) {
    cards.forEach(hit => {
      const data = {}

      const mediaPath = `//${config.cloudinary.host}/${
        config.cloudinary.options.cloud_name
      }/`

      let imgW = 650
      let imgH = 400
      if (type === 'report') {
        imgW = 465
        imgH = 603
      } else if (type === 'document') {
        imgW = 280
        imgH = 363
      } else if (type === 'members') {
        imgW = 158
        imgH = 129
      }

      data.imgSrc =
        hit.contentProperties && hit.contentProperties.picture
          ? `${mediaPath}/c_fill,f_auto,q_auto,g_auto,w_${imgW},h_${imgH}/${
              hit.contentProperties.picture.singleMedia.publicId
            }.${hit.contentProperties.picture.singleMedia.originalFormat}`
          : type === 'members'
          ? hit.webLogo
            ? hit.webLogo
            : ''
          : ''

      // override for page card https://suivi.bigyouth.fr/projects/134?modal=Task-19494-134
      if (data.imgSrc === '') {
        if (hit.contentProperties && hit.contentProperties.backgroundPicture) {
          data.imgSrc = `${mediaPath}/c_fill,f_auto,q_auto,g_auto,w_${imgW},h_${imgH}/${
            hit.contentProperties.backgroundPicture.singleMedia.publicId
          }.${
            hit.contentProperties.backgroundPicture.singleMedia.originalFormat
          }`
        } else {
          data.imgSrc = '/assets/front/card-edito-home.jpg'
        }
      }

      data.fileURL =
        hit.contentProperties && hit.contentProperties.pdf
          ? hit.contentProperties.pdf.pdfLink
            ? `${mediaPath}image/upload/${hit.contentProperties.pdf.pdfLink}`
            : `${mediaPath}image/upload/${
                hit.contentProperties.pdf.singleMedia.publicId
              }.${hit.contentProperties.pdf.singleMedia.originalFormat}`
          : ''

      data.date = ''
      if (hit.contentProperties && hit.contentProperties.date) {
        const formattedDate = moment(hit.contentProperties.date.date)
          .locale(this.locale)
          .format('D MMM YYYY')
        data.date = `<div class="date mb-2">${formattedDate}</div>`
      }

      data.title = type === 'members' ? hit.name : hit.title
      data.desc =
        hit.customProperties && hit.customProperties.excerpt
          ? hit.customProperties.excerpt
          : hit.description
          ? hit.description
          : hit.belonging
          ? hit.belonging
          : ''
      const htmlDesc = stringToHTML(data.desc)
      data.desc = htmlDesc ? htmlDesc.innerText : ''

      data.tag = ''
      if (hit.tags) {
        const t = hit.tags.length > 0 ? hit.tags[0] : { name: '' }
        if (t.name != '') {
          const tagLink = `${window.location.href.split('?')[0]}?${
            config.algolia.env
          }_pages%5BrefinementList%5D%5Btags.name%5D%5B0%5D=${slugify(t.name)}`
          data.tag += `<a href="${tagLink}" class="tag tag--${slugify(
            t.name
          )} tag--selected" data-text="${t.name}">
              <div class="bg-color color-${slugify(t.name)}"></div>
          ${t.name}
          </a>`
        }
      }
      data.url =
        hit.contentProperties && hit.contentProperties.url
          ? hit.contentProperties.url
          : hit.path

      if (type === 'members')
        data.url =
          this.locale == 'en'
            ? hit.frontUrl.replace('/membre/', '/en/membre/')
            : hit.frontUrl
      if (type === 'members') data.website = hit.website ? hit.website : ''

      data.socialnetwork = {}
      data.socialnetwork.type =
        hit.contentProperties && hit.contentProperties.type
          ? hit.contentProperties.type
          : ''
      data.socialnetwork.name =
        hit.contentProperties && hit.contentProperties.name
          ? hit.contentProperties.name
          : ''
      data.socialnetwork.content =
        hit.contentProperties && hit.contentProperties.content
          ? hit.contentProperties.content
          : ''
      data.socialnetwork.url =
        hit._highlightResult &&
        hit._highlightResult.contentProperties &&
        hit._highlightResult.contentProperties.url
          ? hit._highlightResult.contentProperties.url.value
          : ''

      let card = document.createElement('li')
      card.classList.add('card')

      let fragment = document.createDocumentFragment()

      if (type === 'news') {
        card.classList.add('card--actu', 'min-h-1/2')
        card.innerHTML = newsTpl(data)
      } else if (type === 'members') {
        card.classList.add('card--member')
        card.innerHTML = memberTpl(data)
      } else if (type === 'document') {
        card.classList.add('card--download')
        card.innerHTML = downloadTpl(data)
      } else if (type === 'report') {
        card.classList.add('card--report')
        card.innerHTML = reportTpl(data)
      } else if (type === 'job-card') {
        card.classList.add('card--job', 'min-h-1/2')
        card.innerHTML = jobTpl(data)
      } else if (type === 'event') {
        card.classList.add('card--event', 'min-h-1/2')
        card.innerHTML = eventTpl(data)
      } else if (type === 'page') {
        card.classList.add('card--page')
        card.innerHTML = pageTpl(data)
      } else if (type === 'press-release') {
        card.classList.add('card--news', 'min-h-1/2')
        card.innerHTML = pressReleaseTpl(data)
      } else if (type === 'press-summary') {
        data.desc = truncate(data.desc, 450)
        card.classList.add('card--actu', 'min-h-1/2')
        card.innerHTML = pressSummaryTpl(data)
      } else if (type === 'social-network') {
        card.classList.add('card--social-media', 'min-h-1/2')
        card.innerHTML = socialNetworkTpl(data)
      }

      fragment.appendChild(card)

      wrapper.append(card)
    })

    block.classList.remove('hidden')
  },

  triggerResizeForHeaderCalculation() {
    var resizeEvent = window.document.createEvent('UIEvents')
    resizeEvent.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(resizeEvent)
  },

  componentWillUnmount() {},

  /* resizeGrid(e) {
    this.isMobile = !(e.width >= 768)
  },*/
}
